<template>
  <v-container>
    <v-row v-if="isForm">
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{$t("keywords.register")}}</v-toolbar-title>
            <v-row>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(objEditar.nameGetMethod)"
                  name="nameGetMethod"
                  :label="$t('keywords.method_name')"
                  :hint="$t('api_query.hint.name_get_method')"
                  v-model="objEditar.nameGetMethod"
                />
              </v-col>

              <v-col cols="12" sm="6" lg="4">
                <DatabaseSelect
                  :label="$t('keywords.db')"
                  :hint="$t('api_query.hint.data_base')"
                  name="listTenant"
                  :multiple="true"
                  :required="true"
                  v-model="objEditar.listTenant"
                />
              </v-col>

              <v-col cols="12" md="3" v-if="isPlatform">
                <RoutingkeySelect v-model="objEditar.routingkey" :rules="requiredRules(objEditar.routingkey)" />
              </v-col>

              <v-col cols="12" sm="6" lg="4">
                <BeansConfiguration
                  v-model="objEditar"
                  SearchDatabaseClassType="br.com.senior.plutaoapp.consultaapi.process.SearchDatabaseExecutor"
                  ConvertDatabaseResultClassType="br.com.senior.plutaoapp.utils.process.ConvertDatabaseResultExecutor"
                  AuthorizationClassType="br.com.senior.plutaoapp.utils.process.AuthenticationExecutor"
                />
              </v-col>

            </v-row>

            <v-row>
              <v-col cols="12" md="11" sm="10">
                <v-combobox
                  v-model="chips"
                  chips
                  clearable
                  :label="$t('keywords.url_param')"
                  multiple
                  :hint="$t('keywords.url_param')"
                >
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="removeChip(item)"
                    >
                      <span>{{ item }}</span>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="12" md="1" sm="2">
                <v-switch :label="$t('check.active')" v-model="objEditar.active"></v-switch>
              </v-col>

              <v-col cols="12">
                <SQLFormatter
                  :required="true"
                  :query="objEditar.searchQuery"
                  :label="$t('api_query.label.sql_query')"
                  :hint="$t('api_query.hint.sql_query')"
                  placeholder="select :funcionarios as resultado from dual"
                  v-model="objEditar.searchQuery"
                />
              </v-col>

            </v-row>
            <v-row class="pb-3">
              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{$t('keywords.authorization')}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="6">
                          <AuthenticationSelect v-model="objEditar.wsAuthorizationType" :rules="requiredRules(objEditar.wsAuthorizationType)" />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-if="objEditar.wsAuthorizationType === 'Bearer'"
                            name="wsAuthorizationToken"
                            :label="$t('keywords.authentication.token')"
                            v-model="objEditar.wsAuthorizationToken"
                          />
                          <CredentialSelect
                            v-else-if="objEditar.wsAuthorizationType === 'Basic'"
                            name="credentialName"
                            :label="$t('api_query.label.authorization_credential')"
                            v-model="objEditar.credentialName"
                            type="AUTHORIZATION_WS"
                            :required="true"
                          />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row class="mt-5 pt-5">
              <v-col cols="12" class="text-right">
                <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
                <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="integracoes"
          class="elevation-1"
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn color='primary' dark class='mb-2' @click="newItem()" v-text="$t('button.new')" />
              <ImportExportConsultaApi @import="searchAll()" />
            </v-toolbar>
            <SearchField v-model="nameGetMethodSearch" />
          </template>
          <template v-slot:item.active='{ item }'>
            <v-icon small color="green" v-if="item.active">mdi-circle</v-icon>
            <v-icon small color="darkgrey" v-else>mdi-circle</v-icon>
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy" />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  small
                  class="mr-2"
                  @click="testItem(item)"
                >mdi-animation-play</v-icon>
              </template>
              <span>{{$t('api_query.test_api')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="orange"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >mdi-pencil</v-icon>
              </template>
              <span>{{$t('button.edit')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red"
                  small
                  class="mr-2"
                  @click="deleteItem(item)"
                >mdi-delete</v-icon>
              </template>
              <span>{{$t('button.delete')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>{{$t('core.import_export.export')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <ShowLastLogsIcon v-on="on" :integrationName="item.nameGetMethod" processType="consultaapi" />
              </template>
              <span v-text="$t('keywords.latest_logs')" />
            </v-tooltip>
          </template>
          <template v-slot:item.nameGetParameters="{ item }">
            <v-chip v-for="par in item.parametros" :key="par" class="mr-2">{{par}}</v-chip>
          </template>
          <template v-slot:no-data>{{$t('warnings.no_data_found')}}</template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Servico from '@/services/ConsultaApiService'
import DatabaseSelect from '../core/DatabaseSelect'
import SQLFormatter from '../core/SQLFormatter'
import CredentialSelect from '../core/CredentialSelect'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import LocalStorageService from '../../services/LocalStorageService'
import ImportExportService from '@/services/ImportExportService'
import IncludesIgnoreCase from '../../utils/IncludesIgnoreCase'
import ShowLastLogsIcon from '@/components/core/ShowLastLogsIcon.vue'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import BeansConfiguration from '../core/BeansConfiguration.vue'
import AuthenticationSelect from '../core/AuthenticationSelect.vue'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'
import ImportExportConsultaApi from './ImportExportConsultaApi.vue'

export default {
  name: 'ConsultaApi',

  components: {
    DatabaseSelect,
    SQLFormatter,
    CredentialSelect,
    ShowLastLogsIcon,
    LastModify,
    SearchField,
    BeansConfiguration,
    AuthenticationSelect,
    RoutingkeySelect,
    ImportExportConsultaApi
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    search: '',
    nameGetMethodSearch: '',
    isForm: false,
    isUpdating: false,
    objEditar: {
      nameGetMethod: '',
      nameGetParameters: '',
      searchQuery: '',
      searchDatabaseExecutorBean: '',
      convertDatabaseResultExecutorBean: '',
      wsAuthorizationType: '',
      wsAuthorizationToken: '',
      credentialName: '',
      wsAuthorizationBean: '',
      active: false,
      routingkey: '',
      listTenant: [],
      clientPrefix: ''
    },
    objPadrao: {
      nameGetMethod: '',
      nameGetParameters: '',
      searchQuery: '',
      searchDatabaseExecutorBean: '',
      convertDatabaseResultExecutorBean: '',
      wsAuthorizationType: '',
      wsAuthorizationToken: '',
      wsAuthorizationUser: '',
      wsAuthorizationPassword: '',
      wsAuthorizationBean: '',
      active: false,
      routingkey: '',
      listTenant: []
    },
    integracoes: []
  }),

  computed: {
    version () { return this.$versionable.versions.apiQuery },

    headers () {
      return [
        {
          text: this.$t('keywords.method_name'),
          align: 'start',
          sortable: true,
          value: 'nameGetMethod',
          filter: name => IncludesIgnoreCase(name, this.nameGetMethodSearch)
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('check.active'),
          value: 'active',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('keywords.params'),
          sortable: false,
          value: 'nameGetParameters'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    },

    chips: {
      get () {
        if (this.objEditar.nameGetParameters) {
          if (this.objEditar.nameGetParameters.indexOf(',') > 0) {
            return this.objEditar.nameGetParameters.split(',')
          } else {
            return [this.objEditar.nameGetParameters]
          }
        } else {
          return []
        }
      },
      set (value) {
        this.objEditar.nameGetParameters = value.join(',')
      }
    },

    itemsPerPage: {
      get () {
        return this.$cookies.isKey('consultaapi_per_page') ? parseInt(this.$cookies.get('consultaapi_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('consultaapi_per_page', value)
      }
    },

    isPlatform () { return LocalStorageService.isPlatform() }
  },

  mounted () { this.searchAll() },

  methods: {

    removeChip (item) {
      this.chips.splice(this.chips.indexOf(item), 1)
      this.chips = [...this.chips]
    },

    searchAll () {
      Servico.findAll()
        .then(result => {
          this.integracoes = result.data.map(integra => {
            if (integra.nameGetParameters) {
              if (integra.nameGetParameters.indexOf(',') > 0) {
                integra.parametros = integra.nameGetParameters.split(',')
              } else {
                integra.parametros = [integra.nameGetParameters]
              }
            } else {
              integra.parametros = []
            }
            return integra
          })
        })
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.isForm = false
    },

    newItem () {
      this.objEditar = Object.assign({}, this.objPadrao)
      this.isForm = true
      this.isUpdating = false
    },

    editItem (item) {
      Servico.findById(item)
        .then(resp => {
          if (resp.data) {
            this.objEditar = resp.data
            this.isForm = true
            this.isUpdating = true
          }
        })
    },

    async saveItem () {
      this.objEditar.lastModifiedBy = LocalStorageService.getUsername()
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()

      /*
      if (this.isUpdating) {
        const nameGetMethod = this.objEditar.nameGetMethod
        const responseWS = await Servico.findById({ nameGetMethod })
        this.objEditar.routingkey = responseWS.data.routingkey
      }
      */

      if (this.$refs.form.validate()) {
        if (this.isUpdating) {
          Servico.update(this.objEditar)
            .then(result => {
              this.close()
              this.searchAll()
            })
            .catch(error => this.$message.error(`${this.$t('warnings.error.update')} : ${error}`))
        } else {
          Servico.insert(this.objEditar)
            .then(result => {
              this.close()
              this.searchAll()
            })
            .catch(error => this.$message.error(`${this.$t('warnings.error.insert')} : ${error}`))
        }
      }
    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then(result => {
            this.close()
            this.searchAll()
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    },

    testItem (item) {
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      const accessUrl = LocalStorageService.getAccessUrl()
      Servico.findById(item)
        .then(resp => {
          if (resp.data) {
            item = resp.data
            let url = `${accessUrl}/${clientUrlPrefix}/consultaapi/${item.listTenant[0]}/${item.nameGetMethod}/?`
            if (item.nameGetParameters) {
              if (item.nameGetParameters.indexOf(',') > 0) {
                let divisor = ''
                item.nameGetParameters.split(',').forEach(element => {
                  url += divisor + element + '='
                  divisor = '&'
                })
              } else {
                url += item.nameGetParameters + '='
              }
            }

            window.open(url, '_blank')
          }
        })
    },

    exportItem (item) {
      if (confirm(this.$t('warnings.confirm.export'))) {
        ImportExportService.export('consultaapilib', item.nameGetMethod)
          .then(() => this.$message.success(this.$t('warnings.success.export')))
          .catch(error => this.$message.error(`${this.$t('warnings.error.export')} : ${error}`))
      }
    }
  }

}
</script>
